import React, { useCallback, useContext } from "react";

import { withRouter } from "react-router";

import { Box, Flex, Link, Text } from "src/components";

import { colors } from "src/styles";
import { defaultPrevented } from "src/utils";

import Login from "src/banking/authentication/Login";

const MenuLink = props => (
  <Link
    color="muted"
    textTransform="uppercase"
    fontWeight="semibold"
    fontSize={3}
    exact={true}
    textDecoration="none"
    mb={2}
    align={["center", "center", "center", "flex-start"]}
    hover={{
      textDecoration: "underline",
      color: colors.brandGreen,
    }}
    activeStyle={{
      color: colors.brandGreen,
    }}
    {...props}
  >
    {props.children}
  </Link>
);

const CurrentUserMenu = ({ logOut }) => (
  <Flex flexDirection="column">
    <Flex bg="blue" p={2} align="flex-end">
      <Text fontSize={3} color="white" fontWeight="bold" mr={1}>
        Matt Dean
      </Text>
      <Text fontSize={2} color="white" fontWeight="thin">
        Last Login 2 days ago
      </Text>
    </Flex>
    <Flex flexDirection="column" p={3}>
      <MenuLink to="/app">Accounts</MenuLink>
      <MenuLink to="/app/preferences">Preferences</MenuLink>
      <MenuLink to="/" onClick={logOut}>
        Log Out
      </MenuLink>
    </Flex>
  </Flex>
);

const LoginDropdown = ({ loggedIn, logOut, history, location }) => {
  const onLoginComplete = useCallback(() => {
    if (location.pathname === "/app") {
      window.location.reload();
    } else {
      history.push("/app");
    }

    console.warn("on login complete in callback");
  }, []);

  return (
    <Flex
      justify="flex-end"
      flex={1}
      px={[2, 3, 4, 6]}
      pb={2}
      style={{
        position: "absolute",
        zIndex: 100,
        width: "100%",
      }}
    >
      <Box
        justify="center"
        bg="white"
        borderBottomLeftRadius={5}
        borderBottomRightRadius={5}
        width={["100%", 400]}
        flexGrow={[1, 0, 0]}
      >
        {loggedIn ? (
          <CurrentUserMenu logOut={logOut} />
        ) : (
          <Login onComplete={onLoginComplete} />
        )}
      </Box>
    </Flex>
  );
};

export default withRouter(LoginDropdown);



// WEBPACK FOOTER //
// ./src/components/Layout/LoginDropdown.js